import Vue from 'vue';
import { Module } from 'vuex';

import { CategorizedCoursesListState, CategorizedCoursesState, RootState } from 'frontend/types';

const secondaryFeaturedCourses: Module<CategorizedCoursesListState, RootState> = {
  namespaced: true,
  state: () => ({
    items: [] as CategorizedCoursesState[],
  }),
  mutations: {
    setValue(state: CategorizedCoursesListState, value: CategorizedCoursesState[]): void {
      Vue.set(state, 'items', value);
    },
    setNotifyComingSoon(state, { courseId, notifyWhenPublished }) {
      state.items.forEach(({ courses_by_sub_category }) => {
        courses_by_sub_category.forEach(({ courses }) => {
          courses.forEach(c => {
            if (c.course_id === courseId) {
              c.notify_when_published = notifyWhenPublished;
            }
          });
        });
      });
    },
  },
};

export default secondaryFeaturedCourses;
